export const sampleData = {
  "id": 54,
  "module_type": "OP",
  "billing_display": "Service Head",
  "package_amount": 13332,
  "package_name": "Service Name - Assorted",
  "package_code": "AP15",
  "package_id": 54,
  "package_type": "Assorted",
  "package_line": [
    {
      "package_id": 54,
      "package_service_head": "Assorted Service Head",
      "package_head_type": "Service",
      "package_head_id": 83,
      "package_head_amount": 13332,
      "service_data": [
        {
          "package_id": 54,
          "service_details_id": 202,
          "package_detail_id": 185,
          "package_head_id": 83,
          "service_charge": 4444,
          "module_type": "OP",
          "service_name": "Dr Ananthi Aravind",
          "service_code": "SE11",
          "service_head_id": 155,
          "service_head": "OP HEAD 1",
          "service_head_code": "SH5",
          "unit": "1",
          "unit_type": "Nos",
          "gst_percent": 0,
          "is_sharable": false,
          "edit_unit": false,
          "edit_amount": false,
          "edit_discount": false,
          "doctor_name": "Dr Ajin Daniel M.B.B.S., M.S",
          "doctor_id": 280
        },
        {
          "package_id": 54,
          "service_details_id": 201,
          "package_detail_id": 186,
          "package_head_id": 83,
          "service_charge": 4444,
          "module_type": "OP",
          "service_name": "Dr Ajith K Nair",
          "service_code": "SE10",
          "service_head_id": 155,
          "service_head": "OP HEAD 1",
          "service_head_code": "SH5",
          "unit": "1",
          "unit_type": "Nos",
          "gst_percent": 0,
          "is_sharable": false,
          "edit_unit": false,
          "edit_amount": false,
          "edit_discount": false,
          "doctor_name": "Dr Ajin Daniel M.B.B.S., M.S",
          "doctor_id": 280
        },
        {
          "package_id": 54,
          "service_details_id": 203,
          "package_detail_id": 187,
          "package_head_id": 83,
          "service_charge": 4444,
          "module_type": "OP",
          "service_name": "OP SERVICE 1 SHARE",
          "service_code": "SE12",
          "service_head_id": 156,
          "service_head": "OP HEAD 2",
          "service_head_code": "SH6",
          "unit": "1",
          "unit_type": "Nos",
          "gst_percent": 0,
          "is_sharable": true,
          "edit_unit": false,
          "edit_amount": false,
          "edit_discount": false,
          "doctor_name": "Dr Ajin Daniel M.B.B.S., M.S",
          "doctor_id": 280
        }
      ]
    }
  ]
}